import { defineStore } from 'pinia';
import Toastify from 'toastify-js';

export const useProductStore = defineStore({
  id: 'product',
  state: () => ({
    isLoading: false,
    quantity: 0,
    basketSummary: {
      subtotal: "",
      basketCount: 0,
      tax: "",
      total: ""
    },
    basketUrl: '/basket/',
    productData: null,
    selectedVariant: null
  }),
  getters: {
    getBasketCount: (state) => state.basketSummary.basketCount,
    getBasketSummary: (state) => state.basketSummary,
    getSelectedVariant: (state) => state.selectedVariant,
    getProductData: (state) => state.productData
  },
  actions: {
    async fetchBasketCount() {
      try {
        const response = await fetch('/api/basket/count');
        if (!response.ok) throw new Error('Network response was not ok');

        const data = await response.json();
        this.basketSummary.basketCount = data;
      } catch (error) {
        console.error('There was a problem fetching the data:', error);
        this.showErrorToast('There was a problem updating your basket count.');
      }
    },

    async addToBasket({ productReference, quantity, name }) {
      const basketData = { productReference, quantity };

      try {
        const response = await fetch('/api/basket/add', {
          method: 'POST',
          headers: { 'Content-Type': 'application/json' },
          body: JSON.stringify(basketData)
        });

        if (!response.ok) {
          throw new Error('Add to basket failed');
        }

        const data = await response.json();

        if (data.message) {
          console.error(data.message);
          this.showErrorToast(data.message);
          return { success: false, data };
        }

        // this.fetchBasketCount();

        return { success: true, data };
      } catch (error) {
        console.error('Add to basket failed:', error);
        this.showErrorToast('Something went wrong adding this item to your basket.');
        return { success: false, error };
      }
    },

    async removeFromBasket({ productReference, quantity, name }) {
      const basketData = { productReference, quantity };

      try {
        const response = await fetch('/api/basket/remove', {
          method: 'POST',
          headers: { 'Content-Type': 'application/json' },
          body: JSON.stringify(basketData)
        });

        if (!response.ok) {
          throw new Error('Remove from basket failed');
        }

        const data = await response.json();

        await this.fetchBasketCount();

        this.showInfoToast({
          title: 'Removed from your basket',
          name: name || data?.productName || 'Item',
          quantity
        });

        return { success: true, data };
      } catch (error) {
        console.error('Remove from basket failed:', error);
        this.showErrorToast('Something went wrong removing this item from your basket.');
        return { success: false, error };
      }
    },

    // Toast helpers (success removed)
    showInfoToast({ title, name, quantity }) {
      const qtyText = quantity && quantity > 1 ? `${quantity} × ${name}` : name;

      Toastify({
        text: `${title}: ${qtyText}`,
        duration: 3500,
        close: true,
        gravity: 'bottom',
        position: 'right',
        stopOnFocus: true,
        className: 'basket-toast basket-toast--info'
      }).showToast();
    },

    showErrorToast(message) {
      Toastify({
        text: message,
        duration: 5000,
        close: true,
        gravity: 'bottom',
        position: 'right',
        stopOnFocus: true,
        className: 'basket-toast basket-toast--error'
      }).showToast();
    },

    updateIsLoading(isLoading) {
      this.isLoading = isLoading;
    },
    updateBasketUrl(url) {
      this.basketUrl = url;
    },
    updateQuantity(quantity) {
      this.quantity = quantity;
    },
    setProductData(data) {
      this.productData = data;
    },
    setSelectedVariant(variant) {
      this.selectedVariant = variant;
    }
  }
});
